import ElementConfig from '../classes/definitions/formItem/ElementConfig';
import FormItem from '../classes/definitions/formItem/FormItem';
var loginSchema = {
    username: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            placeholder: 'Email',
            type: 'text',
        }),
        elementType: 'input',
        value: '',
        addon: {
            icon: 'fa fa-user-o',
            position: 'left',
        },
        validation: {
            required: true,
            pattern: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        },
        valid: true,
        wrapperClass: 'inputSpacer',
        touched: true,
        errorMsg: 'Моля, въведете валиден email',
        maxLength: '50',
    }),
    password: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            placeholder: 'Password',
            type: 'password',
        }),
        elementType: 'input',
        value: '',
        addon: {
            icon: 'fa fa-lock',
            position: 'left',
        },
        validation: {
            required: true,
        },
        valid: true,
        wrapperClass: 'inputSpacer',
        touched: true,
        errorMsg: 'Моля, въведете валидна парола',
        maxLength: '50',
    }),
    '2fa_token': new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            placeholder: 'Authentication Code',
            type: 'text',
        }),
        elementType: 'input',
        value: '',
        addon: {
            icon: 'fa fa-lock',
            position: 'left',
        },
        validation: {
            required: true,
        },
        valid: true,
        wrapperClass: 'inputSpacer',
        touched: true,
        errorMsg: 'Моля, въведете валиден код',
        maxLength: '50',
    }),
};
export default loginSchema;



//////////////////
// WEBPACK FOOTER
// ./src/schemas/loginSchema.ts
// module id = 627
// module chunks = 0